import { ReferentialKey } from 'api/referential';
import { SearchFilterEnum } from 'api/actor';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { PimFormFieldNames } from './PimFormFieldNames';
import { PimFormValues } from './PimFormValues';

import { gerantInputsConfig } from 'back-office/shared/components/gerant/gerantFields';
export const pimInputsConfig: InputsConfig<keyof PimFormValues> = {
  ...gerantInputsConfig,
  ...addressInputsConfig,
  [PimFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.CompanyName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PIM.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.PIM.PLACEHOLDERS.COMPANY_NAME',
  },
  [PimFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.Phone,
    type: 'tel',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PHONE',
  },
  [PimFormFieldNames.RegistrationNumber]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.RegistrationNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.REGISTRATION_NUMBER',
  },
  [PimFormFieldNames.Capital]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.Capital,
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.CAPITAL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.CAPITAL',
    min: 0,
  },
  [PimFormFieldNames.RcsCity]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.RcsCity,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_CITY',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_CITY',
  },
  [PimFormFieldNames.RcsNumber]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.RcsNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_NUMBER',
  },
  [PimFormFieldNames.Rcp]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.Rcp,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.RCP',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCP',
  },
  [PimFormFieldNames.ComplaintEmail]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.ComplaintEmail,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.COMPLAINT_EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.COMPLAINT_EMAIL',
  },
  [PimFormFieldNames.Mandants]: {
    componentKey: ComponentKey.Custom,
    name: PimFormFieldNames.Mandants,
  },
  [PimFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.FIRST_NAME',
  },
  [PimFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.LAST_NAME',
  },
  [PimFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.Email,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.EMAIL',
    existenceCheck: {
      enabled: true,
      type: 'email',
      searchFilter: SearchFilterEnum.Email,
      debounceMs: 500,
      errorMessage: 'Cette adresse email existe déjà',
    },
  },
  [PimFormFieldNames.Username]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.Username,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.USERNAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.USERNAME',
  },
  [PimFormFieldNames.Password]: {
    componentKey: ComponentKey.InputText,
    name: PimFormFieldNames.Password,
    type: 'password',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.PASSWORD',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PASSWORD',
  },
  [PimFormFieldNames.PlateformeIds]: {
    componentKey: ComponentKey.ReferentialTagInput,
    referentialKey: ReferentialKey.Plateforme,
    name: PimFormFieldNames.PlateformeIds,
    label: 'ACTOR_FORM.PIM.LABELS.ORGANIZATION',
    placeholder: 'COMMON.PLACEHOLDERS.ORGANIZATIONS',
    required: true,
  },
};
